module.exports = __webpack_public_path__ + "static/media/4-1.83c35fa9.png";